import React from 'react';
import { AnimatePresence } from 'framer-motion';

/**
 * @desc This component controls the animating children.
 */
export const AnimationManager = ( props ) => {
	return (
		<AnimatePresence exitBeforeEnter={ props.exitBeforeEnter }>
			{ props.children }
		</AnimatePresence>
	);
};

// set display name
AnimationManager.displayName = 'AnimationManager';
